import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=a7ff5582&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=js"
export * from "./SessionCard.vue?vue&type=script&lang=js"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=a7ff5582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ff5582",
  null
  
)

export default component.exports